import React from "react";
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from "../../../components/table/TableOps";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import EnviarFacturaEmail from './EnviarFacturaEmail'
import Http from "../../../Http";
import ACCESS from "../../../ACCESS";

class Cotizaciones extends TableComponent {

  componentDidMount() {
    this.setState({
      id_motivo: 2,
      folio_relacionado: ''
    }, () => {
      this.tableConfig(
        { dataUrl: 'facturas/filter?type=1', deleteUrl: 'cotizacion/delete', deleteField: 'cliente_nombre', modUrl: '/Catalogo/Facturar' },
        TableOp.Table(null, [
          { label: 'Folio', id: 'tipo_cons' },
          { label: 'Folio 2da Factura', id: 'factura_relacionada' },
          { label: 'Folio Factura Copia', id: 'factura_copia' },
          { label: 'Source', id: 'source' },
          // { label: '# Guia', id: 'folio' },
          { label: 'Cliente', id: 'cliente_nombre' },
          { label: 'RFC', id: 'Rrfc' },
          { label: 'Importe', id: 'total' },
          { label: 'Fecha', id: 'fecha' },
          { label: 'Estatus', id: 'estado' },
          { label: 'Timbrada', id: 'timbrada' },
          { label: 'Fecha Cance.', id: 'cancelada_fecha' },
          { label: 'Cancelacion Acuse', id: 'cancelada_acuse' },
          { label: 'Envio CYC', id: 'id_cyc_envio' },
          { label: 'Usuario', id: 'usuario' },
          { label: 'Guía', id: 'g_folio' },
        ], [
          // { id: 'view', icon: 'visibility' },
          { id: 'cancel', icon: 'cancel', tooltip: 'Cancelar factura', cb: this.cancelarFactura, access: [ACCESS.VENTAS_FACTURAS_CONTADO.CANCELAR_FACTURA] },
          { id: 'email', icon: 'email', tooltip: 'Reenviar correo', cb: this.reenviarFactura, access: [ACCESS.VENTAS_FACTURAS_CONTADO.RE_ENVIAR_CORREO]  },
          { id: 'acuse', icon: 'picture_as_pdf', tooltip: 'Descargar acuse de cancelación', cb: this.descargarAcuse, access: [ACCESS.VENTAS_FACTURAS_CONTADO.CANCELAR_FACTURA] },
        ]))
      this.table();
    })
  }

  descargarAcuse = async (id, row) => {
    try {
      this.setState({ message: 'Descargando acuse...' });
      const Resp = await Http.post(`acuse-cancelacion/pdf`, { tipo: 'facturas', id: row.id }, true, "arraybuffer");
      let response = null;
      try {
        let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
        response = JSON.parse(decodedString);
      } catch (error) {}
      if (response && response.error) {
        this.setState({ message: `Error: ${response.errMsg || 'No se pudo descargar el acuse'}` });
      } else {
        const blob = new Blob([Resp], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `Acuse_Cancelacion_${row.tipo_cons || row.folio || row.id}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.setState({ message: 'Acuse descargado' });
      }
    } catch (error) {
      console.log(error);
      this.setState({ message: 'Error al descargar acuse' });
    }
  }

  cancelarFactura = (id, row) => {
    this.setState({ cancelDialog: { visible: true, row } });
  }

  reenviarFactura = (id, row) => {
    const hasFolioFiscal = (row.FFO && typeof row.FFO === 'string' && row.FFO.trim() !== '') || (row.timbrada && row.timbrada !== 'No');
    if (!hasFolioFiscal) {
      this.setState({ message: 'No se puede enviar una factura sin Folio Fiscal' });
      return;
    }
    this.setState({ reenviarDialog: { visible: true, row } });
  }

  reenviarFacturaClose = (id) => {
    this.setState({ reenviarDialog: { visible: false, row: {} } });
  }

  copiarFacturaClose = async (op) => {
    const { row } = this.state.copyDialog;
    this.setState({ copyDialog: { visible: true, loading: true, row } });
    if (op === 1) {
      await this.copyFactura(row);
      this.setState({ copyDialog: { visible: false, row: {}, loading: false } });
    }
    else {
      this.setState({ copyDialog: { visible: false, row: {} } });
    }
  }

  copiarFactura = (id, row) => {
    this.setState({ copyDialog: { visible: true, row } });
  }

  copyFactura = async (factura) => {
    try {
      let res = await Http.post(`facturacion/copiar`, {
        factura_id_original: factura.id
      });
      if (!res.error) {
        if (res.data && res.data.error_cancelacion) {
          this.setState({ message: res.data.error_cancelacion });
        } else {
          this.setState({ message: `Factura copiada correctamente, Folio Nuevo: ${res.data.tipo_cons}`});
        }
        this.table();
      } else {
        this.setState({ message: `Error al copiar: ${res.errMsg}` });
      }
    } catch (error) {

    }
  }

  cancelarFacturaDialog = async (ans) => {
    const { cancelDialog, id_motivo, id_factura_nueva = false, folio_relacionado } = this.state;
    if (!ans) return;
    try {
      let Res = await Http.post(`facturacion/${cancelDialog.row.id}/cancelar`, {  
        id_motivo, 
        id_factura_nueva,
        folio_relacionado
      });
      if (!Res.error) {
        this.setState({ message: 'Factura cancelada' });
        this.table();
      }
      else {
        this.setState({ message: `Error al cancelar: ${Res.errMsg}` });
      }
    } catch (error) {

    }
    this.setState({ cancelDialog: { visible: false } });
  }

  render() {
    const { 
      cancelDialog = { visible: false, row: {} }, 
      message = null, 
      reenviarDialog = { visible: false, row: {} },
      copyDialog = { visible: false, row: {} },
      id_motivo = 2,
      folio_relacionado,
    } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        <div
          style={{
            display: "flex",
            padding: 10,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>Facturas Contado</h1>
          {
            hasAccess(ACCESS.VENTAS_FACTURAS_CONTADO.CREAR_FACTURA) && (
            <Button
              color="primary"
              variant={"contained"}
              onClick={() => {
                this.props.history.push(`/Ventas/Facturar`);
              }}
            >
              Nueva Factura
            </Button>
            )
          }
        </div>
        <this.TableRender />

        <Dialog
          open={cancelDialog.visible}
          onClick={() => this.cancelarFacturaDialog(false)}
        >
          <DialogTitle>¿Cancelar la factura?</DialogTitle>
          <DialogContent>
            <div className='row' >
              <div className='col-sm-12' >
              </div>
              <div className='col-sm-12' >
                <FormControl >
                  <InputLabel>Motivo de Cancelacion</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={id_motivo}
                    onChange={(e) => { this.setState({ id_motivo: e.target.value }) }}
                  >
                    <MenuItem value={1}>01 - Comprobante emitido con errores con relación.</MenuItem>
                    <MenuItem value={2}>02 - Comprobante emitido con errores sin relación.</MenuItem>
                    <MenuItem value={3}>03 - No se llevó a cabo la operación.</MenuItem>
                  </Select>
                  { id_motivo === 1 ? 
                    <TextField  
                      variant="outlined" 
                      className="form-field" 
                      type={"text"}
                      label={`FOLIO FISCAL O FOLIO DE FACTURA RELACIONADO`} 
                      value={folio_relacionado} 
                      onChange={(e) => { this.setState({ folio_relacionado: e.target.value }) }}
                    />
                    : null
                  }
                </FormControl>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.cancelarFacturaDialog(true)} color="primary">
              Sí, cancelar
            </Button>
            <Button onClick={() => this.cancelarFacturaDialog(false)} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          fullWidth={true}
          maxWidth={"xl"}
          open={reenviarDialog.visible}
          onClose={() => this.reenviarFacturaClose(false)}
          // onClick={() => this.reenviarFacturaClose(false)}
        >
          <DialogTitle>Reenviar Factura</DialogTitle>
          <DialogContent>
            <EnviarFacturaEmail factura={reenviarDialog.row} />
          </DialogContent>
        </Dialog>

        <Dialog 
          title='Hacer una copia de la factura' 
          open={copyDialog.visible} 
          onClose={this.copiarFacturaClose} >
          <DialogTitle>Hacer una copia de la factura</DialogTitle>
          <DialogContent className='row' >
            <div className='col-sm-12' >
              Se va crear una copia de la factura {copyDialog.row.tipo_cons}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.copiarFacturaClose(1)} color="primary">
              Sí, Copiar
            </Button>
            <Button onClick={() => this.copiarFacturaClose(2)} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={message ? true : false}
          autoHideDuration={6000}
          onClose={() => this.setState({ message: null })}
          message={message}
        />
      </div>
    );
  }
}


export default withRouter(Cotizaciones)